export const AVERAGE_RENTOUT_DAY_API_ROUTE = `/next/api/common/average-rentout-day`;
